export default {
  initial: 'initial',
  fetching: 'fetching',
  success: 'success',
  failure: 'failure',
};
